import type React from "react";

import "./ButtonSpinner.css";

const ButtonSpinner: React.FC<{isLoading: boolean}> = ({isLoading}) => (
  <div className={"relative w-0 h-0"}>
    <div className={`${isLoading && "spinner"}`} />
  </div>
);

export default ButtonSpinner;
